import { useState, useEffect, useRef } from "react";
import Table from "../Table/Table";
import api from "../api";
import { useNavigate } from "react-router-dom";
import { Bounce, toast } from "react-toastify";

const Users = () => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [isDownloadOpen, setIsDownloadOpen] = useState(false);
  const navigate = useNavigate();
  const downloadRef = useRef(null);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/users`);
      if (response.status === 200) {
        setUsers(response.data);
      } else if (response.status === 404) {
        toast.error("Nessun operatore trovato!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per visualizzare gli utenti!");

      navigate("/login");
      localStorage.clear();
    } else {
      fetchUsers();
    }
  }, [navigate]);

  const preparedData = users.map((user) => ({
    ...user,
    sedi: Array.isArray(user.sedi) ? user.sedi.join("; ") : "",
  }));

  const columns = [
    { field: "nome", header: "Nome" },
    { field: "cognome", header: "Cognome" },
    { field: "email", header: "Email" },
    { field: "descrizione", header: "Descrizione" },
    { field: "sedi", header: "Sedi" },
  ];

  const handleRowClick = (user) => {
    navigate(`/utenti/${user.id}`, {
      state: { user },
    });
  };

  const handleExport = async (format) => {
    setIsDownloadOpen(false);
    setLoading(true);
    try {
      const response = await api.get("/export/users", {
        params: { format },
        responseType: "blob",
      });
      
      if (response.status === 204) {
        toast.info("Non ci sono dati da scaricare", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        return;
      }
      
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"];
      let filename = `utenti.${format}`;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match) filename = match[1];
      }
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Errore durante il download", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (downloadRef.current && !downloadRef.current.contains(event.target)) {
        setIsDownloadOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Utenti</div>
        <div className="controls">
          <div className="download-menu" ref={downloadRef}>
            <button
              className="download-btn"
              onClick={() => setIsDownloadOpen((prev) => !prev)}
            >
              Scarica
            </button>
            {isDownloadOpen && (
              <div className="download-dropdown">
                <button onClick={() => handleExport("csv")}>CSV</button>
                <button onClick={() => handleExport("xlsx")}>Excel</button>
              </div>
            )}
          </div>
          <div className="add-btn">
            <button onClick={() => navigate("/aggiungi-utente")}>
              + Nuovo utente
            </button>
          </div>
        </div>
      </div>

      <div className="page-content users">
        {users && (
          <Table
            columns={columns}
            data={preparedData}
            onRowClick={handleRowClick}
          />
        )}
      </div>
    </div>
  );
};

export default Users;
